/**
 * Canonical regex for Convex document ID validation.
 * Convex IDs are lowercase alphanumeric strings, typically 20-40 characters.
 */
export const CONVEX_ID_REGEX = /^[a-z0-9]{20,40}$/;

/**
 * Validate if a string is a valid Convex document ID.
 *
 * @param id - The string to validate
 * @returns true if the ID matches Convex ID format
 */
export function isValidConvexId(id: string | undefined): boolean {
  if (!id) {
    return false;
  }
  return CONVEX_ID_REGEX.test(id);
}
